import React, { useState } from "react";
import styles from "./howItWorks.module.css";
import { HowItWorksSteps } from "./howItWorksSteps";
import { useNavigation } from "../../helpers/navigationHelpers";
import { ActiveWebsitePage } from "../../types/ActiveWebsitePageEnum";

export const HowItWorks = () => {
  const { navigateToPage } = useNavigation();
  const [isMailboxModalOpen, setIsMailboxModalOpen] = useState(false);

  // Block scrolling when the modal is open
  if (isMailboxModalOpen) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "";
  }

  // Mailbox locations data
  const mailboxLocations = [
    {
      name: "Bibliotheek Harderwijk",
      address: "Havendam 56, 3841 AA Harderwijk",
      mapUrl:
        "https://www.google.com/maps/place/Bibliotheek+Noordwest+Veluwe+-+Harderwijk/@52.351998,5.6199371,17z/data=!3m2!4b1!5s0x47c633d3c8013b2d:0x7acb626d1b1d0a5f!4m6!3m5!1s0x47c633d6dc9e6b6d:0x6bb9e0717298b410!8m2!3d52.3519948!4d5.622512!16s%2Fg%2F11fzf77m3v?entry=ttu&g_ep=EgoyMDI1MDkyNC4wIKXMDSoASAFQAw%3D%3D",
    },
    {
      name: "Stadsmuseum Harderwijk",
      subtitle: "In het museumcafé, gratis toegankelijk",
      address: "Donkerstraat 4, 3841 CC Harderwijk",
      mapUrl:
        "https://www.google.com/maps/place/Stadsmuseum+Harderwijk/@52.3478742,5.6114641,17z/data=!3m1!4b1!4m6!3m5!1s0x47c633d70037725d:0x35b681e1f54f72f0!8m2!3d52.347871!4d5.616335!16s%2Fg%2F1trxjgyq?entry=ttu&g_ep=EgoyMDI1MDkyNC4wIKXMDSoASAFQAw%3D%3D",
    },
    {
      name: "St Jansdal Harderwijk",
      subtitle: "Eerste etage, bij het stiltecentrum",
      address: "Wethouder Jansenlaan 90, 3844 DG Harderwijk",
      mapUrl: "https://www.google.com/maps/search/?api=1&query=Ziekenhuis+St+Jansdal+Harderwijk",
    },
  ];

  return (
    <div className={styles.howItWorksSection}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className={styles.title}>Hoe werkt het</h2>
          <p className={styles.description}>
            Schrijf een brief aan degene die je mist, of richt de brief aan Opluchtpost. Het kan een korte gedachte zijn,
            iets dat je aan hen doet denken. Je kan ook wat meer vertellen. Maak de brief zoals jij dat wilt. Je kunt de
            brief thuis schrijven of gebruik maken van de kaarten bij de brievenbussen in de stad. Wil je een reactie? Denk
            er dan aan dat je een retouradres vermeldt. Je kan de brief posten in een van onze brievenbussen. Als je een
            retouradres hebt opgeschreven, kan je na enige tijd een reactie terug verwachten in de vorm van een gedicht of
            andere passende bemoediging. We hopen je wat herkenning en/ of goede moed toe te kunnen sturen.
          </p>
        </div>
      </div>

      <HowItWorksSteps />

      <div className={styles.ctaSection}>
        <div className={styles.ctaButtons}>
          <button className={styles.ctaButtonPrimary} onClick={() => navigateToPage(ActiveWebsitePage.FAQ)}>
            Veelgestelde vragen
          </button>
          <button className={styles.ctaButtonSecondary} onClick={() => setIsMailboxModalOpen(true)}>
            Waar vind ik de brievenbus?
          </button>
        </div>
      </div>

      {/* Mailbox Locations Modal */}
      {isMailboxModalOpen && (
        <div
          className={styles.modalOverlay}
          onClick={() => {
            setIsMailboxModalOpen(false);
          }}
        >
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h3 className={styles.modalTitle}>Brievenbus locatie's</h3>
              <button
                className={styles.closeButton}
                onClick={() => {
                  setIsMailboxModalOpen(false);
                }}
              >
                ×
              </button>
            </div>
            <div className={styles.locationsContainer}>
              {mailboxLocations.map((location, index) => (
                <div key={index} className={styles.locationItem}>
                  <div className={styles.locationInfo}>
                    <h4 className={styles.locationName}>{location.name}</h4>
                    {location.subtitle && <p className={styles.locationSubtitle}>{location.subtitle}</p>}
                  </div>
                  <div className={styles.locationAddress}>{location.address}</div>
                  <button className={styles.mapButton} onClick={() => window.open(location.mapUrl)}>
                    Open in maps →
                  </button>
                </div>
              ))}
            </div>
            <div className={styles.modalFooter}>
              <p className={styles.suggestionText}>
                heb je een tip of suggestie om opluchtpost te laten groeien?{" "}
                <a href="mailto:opluchtpost@gmail.com" className={styles.mailLink}>
                  Mail ons
                </a>
                .
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
